export default {"src":"/_next/static/media/golf.2029cd26.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};